module.exports = __webpack_public_path__ + "img/foto-escritorio-1.3333d73a.png";